import {
  getCommonParamsOptions,
  getGlobalParamsOptionsAsync,
  getParamsOptionsAsync
} from '@/utils/common.js'

export const searchFormConfig = {
  formItems: [
    {
      field: 'terminalId',
      type: 'input',
      label: 'terminal.id'
    },
    {
      field: 'sn',
      type: 'input',
      label: 'terminal.sn'
    },
    // {
    //   field: 'customerId',
    //   type: 'select',
    //   label: 'customer.customer-name',
    //   options: [],
    //   isResolveGlobalParams: true,
    //   handler: () =>
    //     getGlobalParamsOptionsAsync('customerList', {
    //       labelParams2: 'customerId'
    //     })
    // },
    {
      field: 'modelId',
      type: 'select',
      label: 'file.model-type',
      isResolveGlobalParams: true,
      options: [],
      handler: () =>
        getGlobalParamsOptionsAsync('terminalModel', {
          isNeedPreFix: false
        })
    },
    {
      field: 'tenantId',
      type: 'treeSelect',
      label: 'user.tenant',
      isResolveGlobalParams: true,
      options: [],
      handler: () => getParamsOptionsAsync('tenantList'),
      isLinkageOptions: true,
      otherOptions: {}
    },
    // {
    //   field: 'merchantId',
    //   type: 'select',
    //   label: 'common.app-merchant-name',
    //   isResolveGlobalParams: true,
    //   options: [],
    //   handler: () =>
    //     getGlobalParamsOptionsAsync('merchantList', {
    //       isNeedPreFix: false,
    //       labelParams2: 'userName'
    //     })
    // },
    {
      field: 'status',
      type: 'select',
      label: 'general.status',
      options: [],
      isResolveGlobalParams: true,
      handler: () => getCommonParamsOptions('status')
    },
    {
      field: 'creationDate',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
